<template>
  <div :class="`nnform-element-container ${this.error ? `has-error`: ``}`">
    <div class="nnform-element-wrap">
      <input
          class="nnform-element"
          :type="private.type"
          :name="this.name"
          :value="modelValue"
          @input="handler"
          :placeholder="label"
      >
      <div v-if="type==='password'" :class="{'nnform-show-password':true,'is-active':this.$data.private.activeEye}" @click="switchType">
        <svg class="nnform-show-password-icon" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 512 512"><path d="M447.1 256.2C401.8 204 339.2 144 256 144c-33.6 0-64.4 9.5-96.9 29.8C131.7 191 103.6 215.2 65 255l-1 1 6.7 6.9C125.8 319.3 173.4 368 256 368c36.5 0 71.9-11.9 108.2-36.4 30.9-20.9 57.2-47.4 78.3-68.8l5.5-5.5-.9-1.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z" fill="#a8a8a8" class="fill-000000"></path>
          <path d="M250.4 226.8c0-6.9 2-13.4 5.5-18.8-26.5 0-47.9 21.6-47.9 48.2s21.5 48.1 47.9 48.1 48-21.5 48-48.1c-5.4 3.5-11.9 5.5-18.8 5.5-19.1-.1-34.7-15.7-34.7-34.9z" fill="#a8a8a8" class="fill-000000"></path></svg>
      </div>
    </div>
    <label :class="{'nnform-element-label':true,'required':required}">{{ label }}</label>

    <div class="nnform-error" v-if="this.error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: "CheckoutInput",
  props: {
    modelValue: null,
    label: String,
    required: Boolean,
    name: String,
    error: String,
    type: {
      type: String,
      default: 'text',
    },
  },
  data: function () {
    return {
      private: {
        activeEye: false,
        type: this.type
      },
    };
  },
  methods: {
    switchType() {
      this.private.activeEye = !this.private.activeEye;

      if (this.private.type === 'password') {
        this.private.type = 'text'
      } else {
        this.private.type = 'password'
      }
    },
    handler(e) {
      this.$emit("update:modelValue", e.target.value);
      this.$emit("unset");
    },
  },
}
</script>

<style scoped>

</style>